import { useState, useEffect } from 'react';

// Simulated South African data generator
export function useMavisData() {
  const [data, setData] = useState({
    dashboard: {
      revenue: 2847350,
      revenueChange: 12.5,
      activeMeters: 14832,
      metersChange: 3.2,
      tokensSold: 1247,
      tokensChange: 8.1,
      pendingAlerts: 23,
      alertsChange: -15
    },
    recentTransactions: [{
      id: 'TXN-8921',
      meter: '04-1234-5678-90',
      amount: 150,
      token: '1234-5678-9012-3456-7890',
      time: '10:42 AM',
      status: 'Success'
    }, {
      id: 'TXN-8920',
      meter: '04-9876-5432-10',
      amount: 500,
      token: '9876-5432-1098-7654-3210',
      time: '10:38 AM',
      status: 'Success'
    }, {
      id: 'TXN-8919',
      meter: '04-5555-4444-33',
      amount: 50,
      token: '5555-4444-3333-2222-1111',
      time: '10:15 AM',
      status: 'Success'
    }, {
      id: 'TXN-8918',
      meter: '04-1111-2222-33',
      amount: 200,
      token: 'Failed',
      time: '09:55 AM',
      status: 'Failed'
    }, {
      id: 'TXN-8917',
      meter: '04-7777-8888-99',
      amount: 100,
      token: '7777-8888-9999-0000-1111',
      time: '09:30 AM',
      status: 'Success'
    }],
    revenueChart: [{
      name: 'Mon',
      revenue: 45000
    }, {
      name: 'Tue',
      revenue: 52000
    }, {
      name: 'Wed',
      revenue: 48000
    }, {
      name: 'Thu',
      revenue: 61000
    }, {
      name: 'Fri',
      revenue: 59000
    }, {
      name: 'Sat',
      revenue: 85000
    }, {
      name: 'Sun',
      revenue: 72000
    }],
    smartMeters: [{
      id: '04-1001-2002-30',
      name: 'Thabo Mbeki',
      address: '142 Vilakazi St, Soweto',
      lat: -26.3438,
      lng: 27.8616,
      reading: 1452.3,
      daily: 12.4,
      status: 'Online',
      lastComm: '2 mins ago',
      history: [10, 12, 11, 14, 12, 15, 12]
    }, {
      id: '04-2002-3003-40',
      name: 'Lerato Khumalo',
      address: '88 Section 3, Tembisa',
      lat: -25.996,
      lng: 28.2268,
      reading: 892.1,
      daily: 8.2,
      status: 'Online',
      lastComm: '5 mins ago',
      history: [8, 7, 9, 8, 8, 10, 8]
    }, {
      id: '04-3003-4004-50',
      name: 'Sipho Ndlovu',
      address: '45 Mxenge Rd, Khayelitsha',
      lat: -34.0388,
      lng: 18.6747,
      reading: 2104.5,
      daily: 18.5,
      status: 'Warning',
      lastComm: '1 hour ago',
      history: [15, 16, 18, 22, 25, 18, 18]
    }, {
      id: '04-4004-5005-60',
      name: 'Amina Patel',
      address: '12 Protea Glen, Soweto',
      lat: -26.31,
      lng: 27.82,
      reading: 560.0,
      daily: 5.1,
      status: 'Online',
      lastComm: '1 min ago',
      history: [5, 4, 5, 6, 5, 5, 5]
    }, {
      id: '04-5005-6006-70',
      name: 'Johan van der Merwe',
      address: '77 Church St, Mamelodi',
      lat: -25.72,
      lng: 28.395,
      reading: 3421.8,
      daily: 24.2,
      status: 'Offline',
      lastComm: '2 days ago',
      history: [22, 24, 23, 0, 0, 0, 0]
    }, {
      id: '04-6006-7007-80',
      name: 'Zanele Dlamini',
      address: '90 Umlazi V, Umlazi',
      lat: -29.97,
      lng: 30.89,
      reading: 1120.4,
      daily: 10.5,
      status: 'Online',
      lastComm: '10 mins ago',
      history: [9, 10, 11, 10, 12, 11, 10]
    }],
    vendors: [{
      id: 'V-001',
      name: 'Soweto Superette',
      location: 'Soweto',
      salesToday: 12500,
      commission: 625,
      status: 'Active',
      rating: 4.8
    }, {
      id: 'V-002',
      name: 'Khayelitsha Spaza',
      location: 'Khayelitsha',
      salesToday: 8400,
      commission: 420,
      status: 'Active',
      rating: 4.5
    }, {
      id: 'V-003',
      name: 'Tembisa Traders',
      location: 'Tembisa',
      salesToday: 15200,
      commission: 760,
      status: 'Active',
      rating: 4.9
    }, {
      id: 'V-004',
      name: 'Mamelodi Mini-Mart',
      location: 'Mamelodi',
      salesToday: 3200,
      commission: 160,
      status: 'Warning',
      rating: 3.2
    }, {
      id: 'V-005',
      name: 'Umlazi Quick Shop',
      location: 'Umlazi',
      salesToday: 9100,
      commission: 455,
      status: 'Active',
      rating: 4.1
    }, {
      id: 'V-006',
      name: 'Alex Corner Store',
      location: 'Alexandra',
      salesToday: 0,
      commission: 0,
      status: 'Offline',
      rating: 2.5
    }],
    analytics: {
      consumptionByArea: [{
        name: 'Soweto',
        value: 45000
      }, {
        name: 'Tembisa',
        value: 32000
      }, {
        name: 'Khayelitsha',
        value: 28000
      }, {
        name: 'Mamelodi',
        value: 24000
      }, {
        name: 'Umlazi',
        value: 21000
      }, {
        name: 'Alexandra',
        value: 15000
      }],
      revenueByVendorType: [{
        name: 'Spaza Shops',
        value: 45
      }, {
        name: 'Supermarkets',
        value: 30
      }, {
        name: 'Online/App',
        value: 20
      }, {
        name: 'Municipal Offices',
        value: 5
      }]
    }
  });

  // Simulate real-time updates for smart meters
  useEffect(() => {
    const interval = setInterval(() => {
      setData(prev => {
        const newMeters = prev.smartMeters.map(meter => {
          if (meter.status === 'Online') {
            return {
              ...meter,
              reading: +(meter.reading + Math.random() * 0.1).toFixed(1),
              daily: +(meter.daily + Math.random() * 0.05).toFixed(1)
            };
          }
          return meter;
        });
        return {
          ...prev,
          smartMeters: newMeters
        };
      });
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return data;
}
export function generateToken() {
  const segments = Array.from({
    length: 5
  }, () => Math.floor(1000 + Math.random() * 9000).toString());
  return segments.join('-');
}
export function formatZAR(amount: number) {
  return new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: 'ZAR',
    minimumFractionDigits: 0
  }).format(amount);
}